<template>
  <FreeBottomSheet :name="name">
    <template #header="{ hide }">
      <FreeHeader class="p-4">
        <template #default>
          <h1 class="text-text-neutral-primary font-medium">
            {{ product.title }}
          </h1>
        </template>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default="{ hide }">
      <div class="space-y-4 px-4 pb-4">
        <h1
          v-if="allowToAddProduct"
          v-price="product.price.amount"
          class="text-text-positive-primary text-center text-2xl font-bold"
        ></h1>
        <!-- eslint-disable vue/no-v-html -->
        <div class="bg-background-neutral-secondary rounded-2xl p-4">
          <img
            v-if="descriptionImage"
            width="40"
            height="40"
            class="mb-2 shrink-0"
            :src="descriptionImage"
            :alt="product.title"
          />
          <div
            class="text-text-neutral-primary space-y-2"
            v-html="fullDescription"
          />
        </div>
        <!-- eslint-enable vue/no-v-html -->
        <FreeButton
          v-if="allowToAddProduct"
          type="button"
          class="sticky bottom-4 w-full"
          :class="Boolean(state?.id) ? 'gray-button' : 'green-main-button'"
          @click="
            () => {
              emit('onChange');
              hide();
            }
          "
        >
          {{ buttonText }}
        </FreeButton>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import {
    FreeBottomSheet,
    FreeHeader,
    FreeCloseButton,
    FreeButton,
  } from 'freedom-shared';
  import { useI18n } from 'vue-i18n';
  import type { MarkedProduct, ProductState } from '@aviata/products-fns';

  const props = withDefaults(
    defineProps<{
      name: string;
      product: MarkedProduct;
      state?: ProductState;
      allowToAddProduct?: boolean;
    }>(),
    {
      state: undefined,
      allowToAddProduct: true,
    },
  );

  const emit = defineEmits<{
    (e: 'onChange'): void;
  }>();

  const { t } = useI18n();

  const buttonText = computed(() =>
    props.state?.id
      ? t('products.products.removeProductButton')
      : t('products.products.addProductButton'),
  );

  const descriptionImage = computed(() => {
    if (props.product.type === 'products.shapagat') {
      return new URL(
        `/src/assets/images/shapagat-co2-icon.svg`,
        import.meta.url,
      ).href;
    }
    return null;
  });

  const fullDescription = computed(() => {
    if (props.product.type === 'products.shapagat') {
      return props.product.full_description
        .replace('{{carbon_route}}', props.product.extra_data.carbon_route)
        .replace(
          '{{carbon_footprint}}',
          parseInt(props.product.extra_data.carbon_footprint || 0),
        );
    }
    return props.product.full_description;
  });
</script>
